export const API_URL = "https://invetix-api.invetix.in"
export const API_KEY = "APIKEYINVETIXCONTACTSALESSUPPORT"